import React, { useEffect } from 'react'
import TestData from './TestData';
import { Autocomplete, Stack, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MASKS } from '../../../../constants/constantList';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import ErrorModal from '../../../ItemProperties/Forms/FieldDataValidation/ErrorModal';

const AlphaMask = ({ okHandler, clear, setClear, selectedNode, updateLength }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const [mask, setMask] = useState('');
  const [maskValue, setMaskValue] = useState('');
  const [testResult, setTestReult] = useState('');
  const [testData, setTestData] = useState('');
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleErrorModal = () => {
    setErrorModal(false);
    setErrorMessage('');
  }

  const handleMask = (maskVal) => {
    let newMask = '';
    if (maskVal === 'PHONE') {
      newMask = MASKS[0];
    } else if (maskVal === 'SSN') {
      newMask = MASKS[1];
    } else if (maskVal === 'ZIP CODE') {
      newMask = MASKS[2];
    } else if (maskVal === 'ZIP CODE +4') {
      newMask = MASKS[3];
    } else {
      newMask = maskVal;
    }
    setMaskValue(newMask)
    if (newMask) updateLength({ type: 'MASK', len: 1 }); 
    else updateLength({ type: 'MASK', len: 0 }); 
    okHandler({ type: 'MASK', value: newMask });
  }

  const testDataFromServer = () => {
    setLoading(true);
    dispatch(api.endpoints.testAlphaMaskData.initiate({
      account,
      data: encodeURIComponent(testData),
      mask: encodeURIComponent(maskValue)
    },{forceRefetch: true})).then((res) => {
      if (res?.data?.current_state === 'SUCCESS') {
        setTestReult(res?.data?.message);
        setLoading(false);
      } else if (res?.data?.current_state === 'ERROR') {
        setErrorModal(true);
        setErrorMessage(res?.data?.message);
        setLoading(false);
      }
    })
  }

  const getTestData = (val) => {
    setTestData(val);
  }

  const recieveTestReqeust = (val) => {
    if (val) {
      testDataFromServer();
    }
  }

  useEffect(() => {
    if (selectedNode?.ADVANCE && selectedNode?.ADVANCE?.MASK) setMask(selectedNode?.ADVANCE?.MASK);
    else if (selectedNode?.MASK) setMask(selectedNode?.MASK);
  }, [selectedNode])

  useEffect(() => {
    if (clear) {
      setClear(false);
    }
  }, [clear])

  return (
    <>
      <div className='padding-16'>
        <Stack spacing={"15px"}>
          <Typography variant="body2">{t('LBL_DATA_FORMAT_RESULT_1')}</Typography>
          <Typography variant="body2">{t('LBL_DATA_FORMAT_RESULT_2')}</Typography>
          <Typography variant="body2">{t('LBL_DATA_FORMAT_RESULT_3')}</Typography>
          <Typography variant="body2">{t('LBL_MUST_USE_CAP_X_AS_MSK_CHAR')}</Typography>

          <Autocomplete
            disablePortal
            freeSolo
            options={MASKS?.map((e) => e)}
            getOptionLabel={(option) => (MASKS.includes(option) ? t(option) : option)}
            isOptionEqualToValue={(option, value) => option === value}
            value={mask}
            sx={{ maxHeight: 300 }}
            onChange={(e, value) => {
              setMask(value);
              handleMask(value);
              okHandler({ type: 'MASK', value: value });
            }}
            onInputChange={(e, value) => {
              setMaskValue(value)
              handleMask(value);
              okHandler({ type: 'MASK', value: value });
            }}
            renderInput={(params) => <TextField
              {...params}
              label={t("LBL_ALPHA_MSK.")}
              onChange={(e) => {
                setMask(e.target.value);
                handleMask(e.target.value);
                okHandler({ type: 'MASK', value: e.target.value });
              }}
              variant="outlined"
              size="small"
              name={'ALPHA_MSK'}
              autoComplete="off"
            />
            }
          />

          <TestData testResult={testResult} getTestData={getTestData} sendTestRequest={recieveTestReqeust} type={''} isLoading={loading} />
        </Stack>
      </div>
      {errorModal && <ErrorModal
        errorModal={errorModal}
        handleErrorModal={handleErrorModal}
        errorMessage={errorMessage}></ErrorModal>}
    </>
  )
}

export default AlphaMask